<template>
  <form @submit.prevent="sendEmail">
    <div class="form-group row">
      <div class="col-md-12">
        <label class="pb-2">Introduce el e-mail asociado a tu cuenta de oommur.</label>
        <input
          class="form-control form-username"
          required
          v-model="email"
          type="name"
          placeholder="Email"
        />
      </div>
      <!-- input-group.// -->
    </div>
    <!-- form-group// -->
    <div class="form-group row">
      <div class="col-md-8 mx-auto">
        <pulse-loader class="ml-loader"  v-if="this.loading"  :color="spinerColor"></pulse-loader>
        <button v-else type="submit" class="btn btn-primary btn-block">
          Enviar
        </button>
      </div>      
    </div>
    <div class="form-group row">
      <a  class="sublink-login" v-on:click = "$parent.viewComponent = 'login'" >Volver al login </a>
    </div>
  </form>
</template>

<script>
import {setData} from './../../services/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'forgotten-pass',
  components: {
    PulseLoader
  },
  data() {
    return {
      email: "",
      loading: false,
      spinerColor: '#00a7e1',
    };
  },
  methods: {
    sendEmail: function () {
        this.loading = true
        setData('auth-oomur/password-reset/',{'email': this.email}).then(res => { 
            if(res.status == 200 && res.data.status == 'OK'){
                this.$noty.success("Hemos enviado un enlace a tu cuenta al e-mail " + this.email +" para que puedas restaurar tu contraseña.")
                this.email = ' '
                this.loading = false
            }else{
                this.loading = false
                this.$noty.error("No existe un usuario activo asociado con este e-mail")
            }
        })
    }
  }
};
</script>

<style scoped>
.ml-loader {
  padding-left: 38px;
}

</style>



// WEBPACK FOOTER //
// src/components/autenticacion/forgotten_pass.vue